export function getPath(state) {
	var fullPath = "/admin_rostering_page";

	if (state.activeView) {
		fullPath += "/" + state.activeView;
		if (state.studentListID)  {
			fullPath += "/" + state.studentListID;
		}
	}

	return fullPath;
}

export function getRouteState(params) {
	var state = {};

	if (params.active_view) {
		state.activeView = params.active_view;

		if (params.student_list_id)  {
			state.studentListID = params.student_list_id;
		}
	} else {
		state.activeView = VIEWS.STUDENTS;
	}

	return state;
}

export var PATH = "/admin_rostering_page/:active_view?/:student_list_id?";

export var VIEWS = {
	TEACHERS: "teachers",
	STUDENTS: "students",
}


// WEBPACK FOOTER //
// ./modules/lib/routing/AdminRosterRouting.js